import { Dispatch, FC, useMemo, useCallback } from 'react';
import { DropdownMenu, DropdownMenuItem } from '@gravity-ui/uikit';
import { VideoInfo } from '../../../types/video/VideoInfo';
import { AvailableDialogs } from '../constants/availableDialogs';
import { commonT, videoListT, toastsT } from '../../../i18n';
import { VideosService } from '../../../api/api-services/videos-service/videosService';
import { toastError, toastInfo } from '../../../libs/toasts/toasts';

type MoreActionsParams = {
    videoInfo: VideoInfo;
    setVideoInfo: Dispatch<VideoInfo>;
    setCurrentOpenedDialog: Dispatch<AvailableDialogs>;
    isMobile?: boolean;
};

export const MoreActions: FC<MoreActionsParams> = ({
    videoInfo,
    setVideoInfo,
    setCurrentOpenedDialog,
    isMobile,
}) => {
    // Дата, после которой расширение файла сохраняется корректно
    const EXTENSION_SUPPORT_DATE = new Date('2026-05-01T00:00:00Z');

    const handleDownloadOriginal = useCallback(async () => {
        try {
            const { download_url } = await VideosService.getDownloadUrl(videoInfo.video_id);

            const createdAt = new Date(videoInfo.created_at);
            if (createdAt < EXTENSION_SUPPORT_DATE) {
                toastInfo.open(toastsT('downloadOriginalWithoutExtension'));
            }

            window.open(download_url, '_blank');
        } catch (error) {
            toastError.open(toastsT('downloadOriginalFailed'));
            console.error('Failed to get download URL:', error);
        }
    }, [videoInfo.video_id, videoInfo.created_at]);

    const actions: DropdownMenuItem[] = useMemo(
        () => [
            // В мобилке кнопка "Поделиться" убрана из отдельной колонки — добавляем в меню
            ...(isMobile
                ? [
                      {
                          action: () => {
                              setVideoInfo(videoInfo);
                              setCurrentOpenedDialog(AvailableDialogs.SHARE);
                          },
                          text: videoListT('actionShare'),
                      },
                  ]
                : []),
            {
                action: () => {
                    setVideoInfo(videoInfo);
                    setCurrentOpenedDialog(AvailableDialogs.EDIT);
                },
                text: commonT('edit'),
            },
            {
                action: handleDownloadOriginal,
                text: videoListT('actionDownloadOriginal'),
            },
            {
                action: () => {
                    setVideoInfo(videoInfo);
                    setCurrentOpenedDialog(AvailableDialogs.DELETE);
                },
                text: commonT('delete'),
                theme: 'danger',
            },
        ],
        [videoInfo, isMobile, handleDownloadOriginal],
    );

    return <DropdownMenu items={actions} />;
};
